import React, { forwardRef } from 'react';

import classNames from 'classnames';

import * as classes from './style.module.scss';
import { TopAnchor } from './TopAnchor';

interface Props {
  className?: string;
  children?: React.ReactNode;
}

const PageContent = forwardRef<HTMLDivElement, Props>(
  ({ className, children }, ref) => {
    return (
      <div
        className={classNames(classes.root, className)}
        // algolia id
        id="content"
        ref={ref}
      >
        <TopAnchor />
        <div className={classes.container}>{children}</div>
      </div>
    );
  },
);

PageContent.displayName = 'PageContent';

export { PageContent };
